import { authHeader } from './auth';
export default {

    methods: {
        getAdminChannels(publisherid,token) {
            const res = this.$axios.get(
                this.$baseUrl +
                this.$api +
                this.$version1 +
                "/channels/admin/get-by-publisher" +
                "?publisher_id=" +
                publisherid,

                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            // console.log(res)
            return res
        },
        // getMerchants: function(params){

        //     return  this.$axios.post(this.$api+"api/merchant/list"+params, {},{headers: authHeader() })
        //         .then((response)=>{
        //             return response.data
        //         })
        // },
        // getMerchantWallet: function(params){

        //     return  this.$axios.post(this.$api+"api/merchant/mfs"+params, {},{headers: authHeader() })
        //         .then((response)=>{
        //             return response.data
        //         })
        // },
        // navigate: function(route){
        //   return  this.$router.push(route)
        // }
    },

    
}
